<mat-form-field [class]="inputClass">
  <mat-label>
    {{label}}
    @if (tooltip) {
      <i class="icon-info pointer" [matTooltip]="tooltip"></i>
    }
  </mat-label>

  <input matInput
         [disabled]="disabled"
         [errorStateMatcher]="errorStateMatcher"
         [matDatepicker]="picker"
         [placeholder]="placeholder"
         [min]="min"
         [max]="max"
         [matDatepickerFilter]="dateFilter"
         [(ngModel)]="value"
         (dateChange)="onDateChange($event.value)"
         (blur)="onTouched()">

  <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>

  <mat-datepicker [touchUi]="viewPortService.isMobile" #picker></mat-datepicker>

  <!-- Show control errors -->
  <mat-error>
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  </mat-error>
</mat-form-field>
